import { combineReducers } from 'redux';

import { loadingReducer } from '$gbusiness/redux/loading';
import { routerReducer } from '$gbusiness/redux/router';
import { cuserReducer } from '$gbusiness/redux/currentUser';
import { toasterReducer } from '$gbusiness/redux/toaster';
import { localStorageReducer } from '$gbusiness/redux/localStorage';
import { factoryReducer } from '$fbusiness/redux/factory';
import { storeReducer } from '$fbusiness/redux/store';
import { departmentReducer } from '$fbusiness/redux/department';
import { categoryReducer } from '$fbusiness/redux/category';
import { itemReducer } from '$fbusiness/redux/item';
import { orderReducer } from '$fbusiness/redux/order';
import { invoiceReducer } from '$fbusiness/redux/invoice';
import { userReducer } from '$fbusiness/redux/user';
import { dailyReportReducer } from '$fbusiness/redux/dailyReport';
import { reportReducer } from '$fbusiness/redux/report';
import { transactionReducer } from '$fbusiness/redux/transaction';
import { batchReducer } from '$fbusiness/redux/batch';
import { serialReducer } from '$fbusiness/redux/serial';
import { threadReducer } from '$fbusiness/redux/thread';
import { broadcastReducer } from '$fbusiness/redux/broadcast';
import { initReducer } from './init';

const appReducer = combineReducers({
  init: initReducer,
  loading: loadingReducer,
  localStorage: localStorageReducer,
  routing: routerReducer,
  currentUser: cuserReducer,
  user: userReducer,
  toaster: toasterReducer,
  factory: factoryReducer,
  store: storeReducer,
  department: departmentReducer,
  category: categoryReducer,
  item: itemReducer,
  order: orderReducer,
  invoice: invoiceReducer,
  dailyReport: dailyReportReducer,
  report: reportReducer,
  broadcast: broadcastReducer,
  transaction: transactionReducer,
  batch: batchReducer,
  serial: serialReducer,
  thread: threadReducer,
});

export default appReducer;
